import moment from "moment";

export const getDateColumns = (currentMonth, selectedYear) => {
  return Array.from({ length: moment(currentMonth).daysInMonth() }, (_, i) => {
    const day = i + 1;
    const date = moment(
      `${day}-${currentMonth.month() + 1}-${selectedYear}`,
      "DD-MM-YYYY"
    );
    // Only include dates from today onward
    return date.isSameOrAfter(moment(), "day") ? date.format("DD MMM") : null;
  }).filter((date) => date !== null);
};
